import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';

import { InlineNotification } from '@paragon/notification-tools';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { copyComponentDesignsToContainerWithoutConfirmation } from '../../store/actions/components';
import { useAppDispatch } from '../hooks';

export interface ComponentCopyDialogProps {
  readonly componentDesignGuids: string[];
  readonly targetContainerGuid: string;
  readonly componentDesignDescendantsNotIncluded: string[];
  readonly namesThatWouldBeDuplicated: string[];
}

export const ComponentCopyConfirmationDialog: FunctionComponent<ComponentCopyDialogProps> = ({
  componentDesignGuids,
  targetContainerGuid,
  componentDesignDescendantsNotIncluded,
  namesThatWouldBeDuplicated,
}) => {
  const dispatch = useAppDispatch();

  return (
    <Dialog
      title="Copy Component Designs?"
      onCancel="close"
      submitText="Copy Anyway"
      onSubmit={() => {
        dispatch(copyComponentDesignsToContainerWithoutConfirmation(componentDesignGuids, targetContainerGuid));
        dispatch(closeCurrentPopup());
      }}
    >
      <Typography>Are you sure you want to copy these components?</Typography>

      {namesThatWouldBeDuplicated.length > 0 && (
        <InlineNotification type="warning" fullWidthWrap>
          The destination project is already using these component names, so the copies will be renamed to keep them
          unique: {namesThatWouldBeDuplicated.join(', ')}.
        </InlineNotification>
      )}

      {componentDesignDescendantsNotIncluded.length > 0 && (
        <InlineNotification type="warning" fullWidthWrap>
          These jacks/subgirders are not included in your selection, but their girders are:{' '}
          {componentDesignDescendantsNotIncluded.join(', ')}. If you copy anyway, the carried component connections
          they&apos;re involved in will not be copied.
        </InlineNotification>
      )}
    </Dialog>
  );
};
